// extracted by mini-css-extract-plugin
module.exports = {"page":"PanelFilter_page__1Yyx4","panel":"PanelFilter_panel__2uB8M"};